import React from 'react'
import Chart from 'react-apexcharts'
import { useGlobal } from '../../shared'
import { urls } from '../../shared/config'
import DashboardCard from '../../containers/Dashboard/components/Dashboard/component/Card'

const BarChart = () => {
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  // console.log('-----customRole', attributes)

  const { data: expenseData } = useGlobal({
    userUrl: `${urls.EXPENSE_CHART}${customRole == 'Admin' ? userSchoolId : ''}`,
  })

  // console.log('---expenseData', expenseData)

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]

  const chartData = Array(12).fill(0)

  if (expenseData && expenseData.chart) {
    expenseData.chart.forEach((dataPoint) => {
      const monthIndex = dataPoint.month - 1
      chartData[monthIndex] = dataPoint.totalPayment
    })
  }

  const seriesData = [
    {
      name: 'Series 1',
      data: chartData,
    },
  ]

  const options = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '85%',
        endingShape: 'rounded',
        borderRadius: 5,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: months,
    },
    yaxis: {
      tickAmount: 5,
      labels: {
        formatter: function (value) {
          if (value >= 1000) {
            return (value / 1000)?.toFixed(1) + 'K'
          }
          return value.toString()
        },
      },
    },
    fill: {
      colors: ['#4473d1'],
      opacity: 1,
      type: 'solid',
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.5,
        },
      },
    },
    selection: {
      enabled: true,
      fill: {
        colors: ['#3C45FF'],
        opacity: 1,
        type: 'solid',
      },
    },
  }

  return (
    <div>
      <div style={{ display: 'flex' }}>
        <DashboardCard title={'Expense'} content={`₹${expenseData?.totalexpense}`} expense />
      </div>
      <Chart options={options} series={seriesData} type="bar" />
    </div>
  )
}

export default BarChart
